import $ from 'jquery';

exports.onRouteUpdate = (location) => {
    if (location.location.hash) {
      setTimeout(() => {
        document.querySelector(`${location.location.hash}`).scrollIntoView();
        $(window).scrollTop( $(window).scrollTop() - 90);
      }, 200);
    }
  };


// WEBPACK FOOTER //
// ./gatsby-browser.js